/* PAEEZE: Bild-Slider in der Produktkarte (Pfeile + Punkte) */
(function () {
  function setup(slider) {
    slider.setAttribute('data-ready', '');
    var track = slider.querySelector('.paeeze-slider__track');
    var prev = slider.querySelector('.paeeze-slider__arrow--prev');
    var next = slider.querySelector('.paeeze-slider__arrow--next');
    var dots = slider.querySelectorAll('.paeeze-slider__dot');
    if (!track) return;

    function currentIndex() {
      return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    }

    function update() {
      var i = currentIndex();
      for (var n = 0; n < dots.length; n++) {
        dots[n].classList.toggle('is-active', n === i);
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= dots.length - 1;
    }

    function go(direction, event) {
      event.preventDefault();
      event.stopPropagation();
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function (e) { go(-1, e); });
    if (next) next.addEventListener('click', function (e) { go(1, e); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  function init() {
    var sliders = document.querySelectorAll('[data-paeeze-slider]:not([data-ready])');
    for (var i = 0; i < sliders.length; i++) setup(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Filter und Sortierung laden die Produkte neu – dann erneut einrichten */
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();